import SeoHead from "@/components/SeoHead";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";

const SIGNUP_URL =
  "https://forms.cloud.microsoft/pages/responsepage.aspx?id=5y5xj4iOMkW8tLKKyAlccZjHjgaBxApOkMRSzRYR72lUNDNPMFZNS1RQR1ZXQTlFU1A0T0E1VURWQy4u&route=shorturl&li_fat_id=df389564-6d33-4e30-81d4-f014201db288";

const paragraphs = [
  "Teknikutvecklingen går snabbare än någonsin. AI, automatisering, digitala arbetsplatser och nya samarbetsformer förändrar inte bara hur vi arbetar utan också var vi kan arbeta. När kontoret inte längre är en plats utan en upplevelse skapas helt nya möjligheter för företag, medarbetare och regioner att växa.",
  "Men vad innebär det i praktiken? Hur påverkas arbetsplatsen när teknik suddar ut gränserna mellan kontor, hem och mötesplatser? Hur bygger vi attraktiva miljöer för innovation, kompetensförsörjning och hållbar tillväxt? Och vilken roll spelar teknikleverantörer, näringsliv och offentlig sektor i att forma morgondagens arbetsliv?",
  "På Norr om Framtiden samlar vi ledande röster från näringsliv, offentlig sektor och teknikbranschen för att diskutera de möjligheter och utmaningar som väntar. Tillsammans utforskar vi hur teknikutvecklingen förändrar våra arbetssätt, våra städer och våra regioner och hur vi kan skapa förutsättningar för människor och verksamheter att utvecklas oavsett geografisk plats.",
  "Under dagen möter du beslutsfattare, experter och innovatörer som delar sina perspektiv på framtidens arbetsplats, regional utveckling och den teknik som möjliggör nästa steg. Genom inspirerande samtal, konkreta exempel och framtidsspaningar får du nya insikter om hur vi tillsammans kan stärka regionens attraktivitet och konkurrenskraft.",
  "Norr om Framtiden handlar inte om teknik för teknikens skull. Det handlar om människor, möjligheter och hur vi bygger ett hållbart och konkurrenskraftigt Norrland i en tid av snabb förändring.",
  "Välkommen till en dag fylld av inspiration, nya perspektiv och samtal om framtiden som redan har börjat.",
];

const agenda = [
  {
    label: "Förmiddag",
    time: "08:30–11:45",
    items: [
      ["08:30–08:45", "Incheckning, kaffe och nätverkande"],
      ["08:45–09:00", "Välkommen – framtidens arbetsliv börjar här"],
      ["09:00–09:45", "Hybridarbete och framtidens teknik – inspiration från Logitech och Samsung"],
      ["09:45–10:15", "Kaffe, samtal och nya möten"],
      ["10:15–11:00", "Från AI-verktyg till smartare arbetssätt – AI-labbet, TD Synnex och Microsoft Teams"],
      ["11:00–11:45", "Microsoft Copilot samt panelsamtal om framtidens arbetsliv och regional utveckling"],
    ],
  },
  {
    label: "Eftermiddag",
    time: "13:30–17:00",
    items: [
      ["13:30–13:45", "Incheckning, kaffe och nätverkande"],
      ["13:45–14:00", "Välkommen – framtidens arbetsliv börjar här"],
      ["14:00–14:45", "Hybridarbete och framtidens teknik – inspiration från Logitech och Samsung"],
      ["14:45–15:15", "Kaffe, samtal och nya möten"],
      ["15:15–16:00", "Från AI-verktyg till smartare arbetssätt – AI-labbet, TD Synnex och Microsoft Teams"],
      ["16:00–17:00", "Microsoft Copilot och panelsamtal om framtidens arbetsliv och regional utveckling"],
    ],
  },
];

const speakers = [
  {
    name: "Henrik Byström",
    role: "Founding partner, AI-labbet",
    bio: "Moderator och en av Sveriges främsta tankeledare inom digitalisering, AI och framtidens arbetsplats.",
  },
  {
    name: "Christoffer Frisell",
    role: "Founding partner, AI-labbet",
    bio: "Moderator och en av Sveriges ledande tankeväckare inom affärsutveckling genom AI och ny teknik.",
  },
  {
    name: "Anja Palm",
    role: "Näringslivschef, Skellefteå Kommun",
    bio: "Ledande drivkraft i Skellefteå med fokus på att stärka Skellefteås näringsliv och skapa förutsättningar för investeringar, utveckling och framtidstro i kommunen.",
  },
  {
    name: "Peter Juneblad",
    role: "Näringslivschef, Umeå Kommun",
    bio: "Brinner för att utveckla Umeås tillväxtmöjligheter och bygga broar mellan människor, idéer och organisationer för att skapa långsiktig regional utveckling.",
  },
  {
    name: "Benny Andersson",
    role: "Nordisk marknadschef B2B, Logitech",
    bio: "Inspirerar och utvecklar framtidens arbetsplats där teknik hjälper människor och organisationer att nå sin fulla potential.",
  },
  {
    name: "Martin Jamteg",
    role: "Teknisk lösningsspecialist, Logitech",
    bio: "Teknisk specialist med fokus på att utveckla nya arbetssätt och stärka samarbete med hjälp av ny teknik.",
  },
  {
    name: "Jesper Wihlborg",
    role: "Säljchef, Samsung Electronics",
    bio: "Utvecklar framtidens arbetsplatser med människans upplevelse, samspel och potential i centrum.",
  },
  {
    name: "Åsa Magnusson",
    role: "Partnerutvecklare, Microsoft",
    bio: "Inspirerar till framtidens arbete där samarbete och AI driver nya sätt att tänka, arbeta och utvecklas.",
  },
  {
    name: "Adam Palm",
    role: "Partnerutvecklare, Microsoft",
    bio: "Teknisk specialist som hjälper människor att utveckla arbetssätt och möjligheter genom AI och samarbete.",
  },
  {
    name: "Andreas Svensson",
    role: "Nordisk partnerutvecklare, TD Synnex",
    bio: "Erfaren affärsutvecklare som skapar värde genom starka partnerskap, kundinsikt och lösningar baserat på ny teknik.",
  },
];

const NorrOmFramtiden = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SeoHead
        title="Norr om framtiden | En dag om teknik, innovation och regional utveckling"
        description="En dag om teknik, innovation, framtidens arbete och regional utveckling – med ledande röster från näringsliv, offentlig sektor och teknikbranschen."
        path="/norr-om-framtiden"
      />

      <Header />

      <main className="flex-1">
        <section className="relative overflow-hidden pt-32 pb-16 md:pt-40 md:pb-24 px-4 sm:px-6">
          <div
            aria-hidden
            className="absolute top-0 left-1/2 -translate-x-1/2 w-[60rem] h-[40rem] bg-gradient-radial-glow opacity-60 pointer-events-none"
          />
          <div
            aria-hidden
            className="absolute inset-0 bg-grid-faint opacity-30 pointer-events-none"
          />

          <div className="relative container mx-auto max-w-3xl">
            <Reveal>
              <p className="text-sm font-semibold tracking-widest text-primary uppercase mb-4">
                Event
              </p>
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground leading-tight mb-6">
                Norr om framtiden{" "}
                <span className="text-muted-foreground font-light">|</span> En dag
                om teknik, innovation, framtidens arbete och regional utveckling
              </h1>
              <div className="h-1 w-20 rounded-full bg-gradient-brand mb-8" />
              <p className="mb-10">
                <a
                  href={SIGNUP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center rounded-full bg-gradient-brand px-6 py-3 text-base font-semibold text-primary-foreground transition-opacity hover:opacity-90"
                >
                  Anmäl dig här
                </a>
              </p>
            </Reveal>

            <div className="space-y-6">
              {paragraphs.map((text, i) => (
                <Reveal key={i} delay={i * 60}>
                  <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
                    {text}
                  </p>
                </Reveal>
              ))}
              <Reveal delay={paragraphs.length * 60}>
                <p>
                  <a
                    href={SIGNUP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center rounded-full bg-gradient-brand px-6 py-3 text-base font-semibold text-primary-foreground transition-opacity hover:opacity-90"
                  >
                    Anmäl dig här
                  </a>
                </p>
              </Reveal>
            </div>

          </div>
        </section>

        <section className="relative overflow-hidden py-16 md:py-24 px-4 sm:px-6 bg-surface-1">
          <div className="relative container mx-auto max-w-3xl">
            <Reveal>
              <p className="text-sm font-semibold tracking-widest text-primary uppercase mb-3">
                Agenda
              </p>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground leading-tight mb-4">
                Norr om framtiden – agenda
              </h2>
              <div className="h-1 w-20 rounded-full bg-gradient-brand mb-6" />
              <p className="text-base md:text-lg text-muted-foreground leading-relaxed mb-10">
                En inspirerande halvdag om framtidens arbetsliv, AI och regional
                utveckling. Tiderna är ungefärliga.
              </p>
            </Reveal>

            <div className="space-y-10">
              {agenda.map((block, bi) => (
                <Reveal key={block.label} delay={bi * 80}>
                  <div className="rounded-2xl border border-border bg-background/60 p-5 sm:p-7">
                    <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 mb-5">
                      <h3 className="text-lg font-semibold text-foreground uppercase tracking-wide">
                        {block.label}
                      </h3>
                      <span className="text-sm font-medium text-primary">
                        {block.time}
                      </span>
                    </div>
                    <ul className="divide-y divide-border">
                      {block.items.map(([time, text]) => (
                        <li
                          key={time}
                          className="grid grid-cols-1 sm:grid-cols-[8.5rem_1fr] gap-1 sm:gap-4 py-3"
                        >
                          <span className="text-sm font-semibold text-foreground tabular-nums">
                            {time}
                          </span>
                          <span className="text-sm md:text-base text-muted-foreground leading-relaxed">
                            {text}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        <section className="relative overflow-hidden py-16 md:py-24 px-4 sm:px-6">
          <div className="relative container mx-auto max-w-5xl">
            <Reveal>
              <p className="text-sm font-semibold tracking-widest text-primary uppercase mb-3">
                Talare
              </p>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground leading-tight mb-4">
                Röster under dagen
              </h2>
              <div className="h-1 w-20 rounded-full bg-gradient-brand mb-10" />
            </Reveal>

            <div className="grid gap-6 sm:grid-cols-2">
              {speakers.map((s, i) => (
                <Reveal key={s.name} delay={(i % 2) * 80}>
                  <div className="h-full rounded-2xl border border-border bg-surface-1 p-6">
                    <h3 className="text-lg font-semibold text-foreground">
                      {s.name}
                    </h3>
                    <p className="text-sm font-medium text-primary mt-1 mb-3">
                      {s.role}
                    </p>
                    <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                      {s.bio}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      </main>


      <Footer />
    </div>
  );
};

export default NorrOmFramtiden;
